import { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { useHistory } from 'react-router-dom';
import { HOME_URL } from '../../../const/URL.const';
import { useAuthenticationContext } from '../../../yoello-lib/modules/auth/AuthenticationContext';
import { useSnackbarMessages } from '../../../yoello-lib/modules/components/snackbar/SnackbarContext';
import { IResetPassword } from '../types.d';
import { useCheckUserVerification } from '../util/useCheckUserVerification';
import useGetResetPasswordParams from './useGetResetPasswordParams';

export function useResetPasswordView() {
  useCheckUserVerification();
  const { forgotPasswordSubmit } = useAuthenticationContext();
  const [ isLoading , setIsLoading] = useState<boolean>(false);
  const { username , isLoading:isParamsReady } = useGetResetPasswordParams();
  const { sendSnackbarMessage } = useSnackbarMessages()!;
  const history = useHistory();
  const { t }  = useTranslation();

  useEffect(()=>{
    if(!username && !isParamsReady){
      history.push(HOME_URL);
      sendSnackbarMessage(
        t("forms.forgotPassword.Errors.invalidEmail").toString(),
        "error"
      );
    }
  // eslint-disable-next-line  
  },[isParamsReady])

  async function resetPassword(data:IResetPassword) {
    setIsLoading(true);
    if (data.password !== data.confirmPassword) {
      sendSnackbarMessage(
        t("forms.forgotPassword.Errors.passwordMismatch").toString(),
        "error"
      );
      setIsLoading(false);
      return;
    }
    try {
      const _email = username!;
      await forgotPasswordSubmit(_email, data.code, data.password);
      sendSnackbarMessage(
        t(
          "forms.forgotPassword.Texts.updatePasswordSuccessful"
        ).toString(),
        "success"
      );
      setIsLoading(false);
      history.push(HOME_URL);
    } catch (err: any) {
      if (err.message.toLowerCase().includes("invalid verification code")) {
        sendSnackbarMessage(
          t("forms.forgotPassword.Errors.invalidCode").toString(),
          "error"
        );
      } else if (
        err.message.toLowerCase().includes("attempt limit exceeded")
      ) {
        sendSnackbarMessage(
          t(
            "forms.forgotPassword.Errors.attemptLimitExceeded"
          ).toString(),
          "error"
        );
      } else if (
        err.message.toLowerCase().includes("id combination not found")
      ) {
        sendSnackbarMessage(
          t("forms.forgotPassword.Errors.invalidEmail").toString(),
          "error"
        );
      } else {
        sendSnackbarMessage(
          t("forms.forgotPassword.Errors.genericResetError").toString(),
          "error"
        );
      }
      setIsLoading(false);
    }
  }

  return {
    isLoading,
    isParamsReady,
    resetPassword
  }
}
